module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-8.7a754d65.png";